import { Link } from "react-router-dom";
import { Bot, ArrowLeft, FileText, Users, GraduationCap, BookOpen } from "lucide-react";
import HermesChat from "@/components/HermesChat";


import TopNav from "@/components/TopNav";
export default function AgentSupport() {
  return (
    <div className="min-h-screen bg-app flex flex-col">
      <TopNav />
      {/* Header */}
      <header className="border-b border-slate-200 bg-app/80 backdrop-blur-lg sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <Link to="/dashboard" className="text-slate-600 hover:text-slate-700">
              <ArrowLeft className="w-5 h-5" />
            </Link>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-indigo-600 flex items-center justify-center">
                <Bot className="w-5 h-5 text-white" />
              </div>
              <div>
                <span className="font-['Barlow_Condensed'] text-xl font-semibold tracking-tight">
                  AGENT SUPPORT
                </span>
                <p className="text-xs text-slate-8000">AllBaise assistant (powered by O-Bot)</p>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Chat */}
      <div className="flex-1 max-w-4xl mx-auto w-full px-6 py-4 flex flex-col">
        <HermesChat
          contextHint="[Super Bot - all hubs]"
          title="AGENT SUPPORT"
          icon={Bot}
          color="from-indigo-600 to-indigo-700"
          accentColor="text-indigo-400"
          layout="full"
          placeholder="Ask me anything about your organization..."
          suggestedQuestions={[
            { icon: FileText, text: "What documents do we have?", color: "text-blue-400" },
            { icon: Users, text: "Show me the team structure", color: "text-emerald-400" },
            { icon: GraduationCap, text: "What training is available?", color: "text-amber-400" },
            { icon: BookOpen, text: "Find SOPs for compliance", color: "text-cyan-400" },
          ]}
        />
      </div>
    </div>
  );
}
